import * as moment from 'moment-timezone'

export function buildRelativeMinutesLanguage(timeInMinutes: number): string {
    if (timeInMinutes === null) {
        return
    }
    // relative language strings initialized
    let daysText
    let hoursText
    let minutesText
    let textPhrase: string[] = []

    let timeInHours

    if (timeInMinutes >= 1440) {
        const dayConversion = dayConversionFromMinutes(timeInMinutes)
        textPhrase.push(dayConversion[0] && `${dayConversion[0]} day${dayConversion[0] > 1 ? 's' : ''}`)
        timeInHours = dayConversion[1]
    }

    const hourConversion = minuteConversionFromHours(timeInHours ?? timeInMinutes / 60)

    hourConversion[0] && textPhrase.push(`${hourConversion[0]} hour${hourConversion[0] > 1 ? 's' : ''}`)
    hourConversion[1] && textPhrase.push(`${hourConversion[1]} minute${hourConversion[1] > 1 ? 's' : ''}`)

    return textPhrase.join(', ')
}

// --------------------- conversion functions --------------------- //

const dayConversionFromMinutes = (minutes: number): number[] => {
    const days = minutes / 24 / 60
    const [day, partialDay] = days.toString().split('.')

    let leftOverHours: number = 0

    if (partialDay) {
        leftOverHours = parseFloat(`.${partialDay}`) * 24
    }

    return [parseInt(day, 10), leftOverHours]
}

const minuteConversionFromHours = (hours: number) => {
    const [hour, partialHour] = hours.toString().split('.')
    let minutes: number = 0
    if (partialHour) {
        minutes = Math.round(parseFloat(`.${partialHour}`) * 60)
    }

    return [parseInt(hour, 10), minutes]
}

/**
 * Creates send object with human language days and time from configuration.
 * @param feed
 * @param sendNumber used to determine which set of send times to build from
 */
export const sendTimesBuilder = (feed: any, sendNumber: number) => {
    const send: any = {
        days: '',
        time: '',
    }

    if (!feed[`send${sendNumber}_time`]) {
        return send
    }

    const daysOfWeek = feed[`send${sendNumber}_days_of_week`]
    const tz = feed[`send${sendNumber}_time_zone`]
    const time = feed[`send${sendNumber}_time`]
    const formattedTz = tz && formatTimeZone(tz)

    send.days = daysOfWeek && convertToStringDay(daysOfWeek)
    send.time = time && tz && `${moment(time, 'HH:mm').format('h:mm A')} ${formattedTz}`

    return send
}

export const convertToStringDay = (days: any[]) => {
    const daysOfWeek = ['Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

    if (days.length === 7) {
        return 'Every Day'
    }

    if (!days.includes(6) && !days.includes(7) && days.length === 5) {
        return 'Weekdays'
    }

    return days
        .map((day) => {
            return daysOfWeek[day - 1]
        })
        .join(', ')
}

const formatTimeZone = (timezone: string) => {
    if (timezone === 'STZ') {
        return 'STZ'
    }

    return moment.tz(timezone).zoneAbbr()
}
